export const RefValue = ({ value, record }) => value == null ? '' : (Math.round(value*100)/100).toFixed(2);
